var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepthOverviewMiniAppAsRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 135,
    viewBox: "0 0 193 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 135,
    rx: 7,
    fill: "#94618F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepthOverviewMiniAppAsRectangle);
export default __webpack_public_path__ + "static/media/depth_overview_mini_app_as_rectangle.191da2e278a1f16386c37e960a39179d.svg";
export { ForwardRef as ReactComponent };